(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bsw-home-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-home-navigation')) {
  customElements.define('bsw-home-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      
      const toggle = this.querySelector('.menu-toggle');
      const menu = this.querySelector('#mobile-menu');
      const searchToggle = this.querySelector('[data-search-toggle]');
      const search = this.querySelector('#bsw-home-search');
      const iconHamburger = toggle ? toggle.querySelector('.icon-hamburger') : null;
      const iconClose = toggle ? toggle.querySelector('.icon-close') : null;

      // Sync Dynamic Body Offset accurately without CLS
      const updateOffset = () => {
        const height = this.offsetHeight;
        if (height > 0) {
          document.documentElement.style.setProperty('--bsw-header-height', height + 'px');
        }
      };
      window.requestAnimationFrame(updateOffset);
      window.addEventListener('resize', updateOffset, { signal, passive: true });

      // Immediate 1st Scroll Hide/Show Behavior
      let lastY = window.pageYOffset || document.documentElement.scrollTop;
      let ticking = false;

      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const currentY = window.pageYOffset || document.documentElement.scrollTop;

            if (menu && !menu.hidden) {
              this.classList.remove('header-hidden');
              lastY = currentY;
              ticking = false;
              return;
            }

            // Top of the page
            if (currentY <= 10) {
              this.classList.remove('header-hidden', 'header-sticky');
            } 
            // Pehli scroll down par turant hide karega
            else if (currentY > lastY && (currentY - lastY > 2)) {
              this.classList.add('header-hidden');
              this.classList.remove('header-sticky');
            } 
            // Scroll up karte hi turant wapas layega
            else if (currentY < lastY && (lastY - currentY > 2)) {
              this.classList.remove('header-hidden');
              this.classList.add('header-sticky');
            }

            lastY = currentY <= 0 ? 0 : currentY;
            ticking = false;
          });
          ticking = true;
        }
      }, { signal, passive: true });

      // Announcement Slider Auto Rotation
      const slides = this.querySelectorAll('.announcement-slide');
      const intervalSpeed = parseInt(this.dataset.autoplay, 10) * 1000;

      if (slides.length > 1 && intervalSpeed > 0) {
        let currentIndex = 0;
        const slideInterval = setInterval(() => {
          slides[currentIndex].classList.remove('is-active');
          currentIndex = (currentIndex + 1) % slides.length;
          slides[currentIndex].classList.add('is-active');
        }, intervalSpeed);

        signal.addEventListener('abort', () => clearInterval(slideInterval));
      }

      // Mobile Menu Actions
      const closeMenu = () => { 
        if (!menu || !toggle) return;
        menu.hidden = true; 
        menu.classList.remove('open'); 
        toggle.setAttribute('aria-expanded', 'false'); 
        toggle.setAttribute('aria-label', this.dataset.openLabel || 'Open Menu'); 
        if (iconHamburger) iconHamburger.style.display = 'block';
        if (iconClose) iconClose.style.display = 'none';
      };

      if (toggle && menu) {
        toggle.addEventListener('click', () => { 
          const open = toggle.getAttribute('aria-expanded') !== 'true'; 
          menu.hidden = !open; 
          menu.classList.toggle('open', open); 
          toggle.setAttribute('aria-expanded', String(open)); 
          toggle.setAttribute('aria-label', open ? (this.dataset.closeLabel || 'Close Menu') : (this.dataset.openLabel || 'Open Menu')); 
          if (iconHamburger) iconHamburger.style.display = open ? 'none' : 'block';
          if (iconClose) iconClose.style.display = open ? 'block' : 'none'; 
          
          if (open) {
            this.classList.remove('header-hidden');
            this.classList.add('header-sticky');
          }
        }, { signal });

        menu.addEventListener('click', event => { 
          if (event.target.closest('a')) closeMenu(); 
        }, { signal });
      }

      // Mobile Accordion Submenu Toggle
      const submenuToggles = this.querySelectorAll('.mobile-dropdown-toggle');
      submenuToggles.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const isExpanded = btn.getAttribute('aria-expanded') === 'true';
          const item = btn.closest('.mobile-nav-item');
          const submenu = item ? item.querySelector('.mobile-submenu') : null;
          
          if (submenu) {
            submenu.hidden = isExpanded;
            btn.setAttribute('aria-expanded', String(!isExpanded));
            btn.classList.toggle('is-open', !isExpanded);
          }
        }, { signal });
      });

      // Search Drawer Open/Close
      if (searchToggle && search) {
        searchToggle.addEventListener('click', () => { 
          search.hidden = !search.hidden; 
          searchToggle.setAttribute('aria-expanded', String(!search.hidden)); 
          if (!search.hidden) {
            const input = search.querySelector('input[type="search"]');
            if (input) input.focus();
          }
        }, { signal });
      }

      // ESC Key Listener
      this.addEventListener('keydown', event => { 
        if (event.key !== 'Escape') return; 
        if (search && !search.hidden) { 
          search.hidden = true; 
          if (searchToggle) {
            searchToggle.setAttribute('aria-expanded', 'false'); 
            searchToggle.focus(); 
          }
        } else if (menu && !menu.hidden) { 
          closeMenu(); 
          if (toggle) toggle.focus(); 
        } 
      }, { signal });

      window.matchMedia('(min-width: 781px)').addEventListener('change', closeMenu, { signal });
    }

    disconnectedCallback() { 
      if (this.controller) {
        this.controller.abort(); 
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsw-home-planner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-home-planner')) {
  customElements.define('bsw-home-planner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;

      const form = this.querySelector('[data-bsw-calc-form]');
      if (!form) return;

      const widthInput = this.querySelector('[data-bsw-wall-width]');
      const heightInput = this.querySelector('[data-bsw-wall-height]');
      const allowanceInput = this.querySelector('[data-bsw-allowance]');
      const errorElem = this.querySelector('[data-bsw-calc-error]');
      const outputArea = this.querySelector('[data-bsw-area-output]');
      const outputBase = this.querySelector('[data-bsw-base-output]');
      const outputTotal = this.querySelector('[data-bsw-total-output]');

      let calcQueued = false;

      const calculate = () => {
        calcQueued = false;
        const width = Math.max(0, widthInput.valueAsNumber || 0);
        const height = Math.max(0, heightInput.valueAsNumber || 0);
        const wastePercent = Number(allowanceInput.value) || 0;

        const valid = Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0 && width <= 1000 && height <= 1000;
        
        errorElem.textContent = valid ? '' : this.dataset.error;
        
        if (!valid) { 
          outputArea.textContent = '—';
          outputBase.textContent = '—';
          outputTotal.textContent = '—';
          return; 
        }

        const area = width * height;
        const unitsNeeded = Math.ceil(area * 4.5);
        const extraUnits = wastePercent > 0 ? Math.ceil(Math.round(unitsNeeded * (100 + wastePercent)) / 100) : unitsNeeded;  

        outputArea.textContent = area.toFixed(1).replace('.0', '');
        outputBase.textContent = unitsNeeded.toLocaleString();
        outputTotal.textContent = extraUnits.toLocaleString();
      };

      const requestCalculation = () => {
        if (!calcQueued) {
          calcQueued = true;
          window.requestAnimationFrame(calculate);
        }
      };

      form.addEventListener('input', requestCalculation, { signal, passive: true });
      form.addEventListener('change', requestCalculation, { signal, passive: true });
      form.addEventListener('submit', event => { 
        event.preventDefault(); 
        calculate(); 
      }, { signal });

      calculate();
    }

    disconnectedCallback() { 
      if (this.controller) {
        this.controller.abort(); 
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
